<div class="section">
    <app-segobjectpropertymap-panel></app-segobjectpropertymap-panel>
    <app-saved-free-selections></app-saved-free-selections>
</div>
<div class="section scroll">
    <app-plot-data-selection></app-plot-data-selection>
    <app-selection-manipulation></app-selection-manipulation>
    <app-scatter-plot></app-scatter-plot>
    <app-tsne-job></app-tsne-job>
    <app-umap-job></app-umap-job>
    <app-rectangular-selection></app-rectangular-selection>
</div>
